<app-wrapper>
  <div class="mb-9">
    <div class="row g-3 mb-4">
      <div class="col-auto">
        <h2 class="mb-0">Бармены</h2>
      </div>
    </div>

    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <div class="search-box">
            <div class="position-relative">
              <input type="text" class="form-control search-input search" [(ngModel)]="search" name="search"
                placeholder="Поиск" (keyup.enter)="searchItems()" />
              <i class="fa-solid fa-search search-box-icon"></i>
            </div>
          </div>
        </div>
        <div class="col-auto flex-grow-1">

        </div>
        <div class="col-auto">
          <button routerLink="/bartenders/edit/new" class="btn btn-primary">
            <i class="fa-solid fa-plus"></i>&nbsp;Добавить бармена
          </button>
        </div>
      </div>
    </div>

    <div class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
      <div class="table-responsive mx-n1 px-1">
        <table class="table fs--1 mb-0">
          <thead>
            <tr>
              <th style="width: 30%;">Аватар</th>
              <th style="width: 30%;">Фамилия имя</th>
              <th>Рейтинг</th>
              <th></th>
              <!-- <th style="width: 30%;"></th> -->
            </tr>
          </thead>
          <tbody class="list">
            @for (item of items; track item) {
            <tr>
              <td>
                @if (item.imagePath) {
                <img [src]="item.imagePath" />
                }
                @if (!item.imagePath) {
                <img src="/no-image.png" />
                }
              </td>
              <td>
                <a [routerLink]="[ '/bartenders/edit/' + item.id]">
                  {{ item.lastName }} {{ item.name }}
                </a>
              </td>
              <td>
                {{ item.rating | number: '.0-1' }}
              </td>
              <td>
                <button class="btn btn-danger" (click)="deleteItem(item)">Удалить</button>
                &nbsp;
                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#list-of-votes-modal"
                  (click)="showVotes(item)">Отзывы</button>
              </td>
            </tr>
            }
            @if (!isBusy && items.length == 0) {
            <tr>
              <td colspan="10" class="text-center">
                Список пуст
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    @if (isBusy) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
    }
  </div>
</app-wrapper>

<div class="modal fade" id="list-of-votes-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title text-white" id="staticBackdropLabel">Отзывы пользователей</h5>
        <button class="btn p-1" type="button" data-bs-dismiss="modal" aria-label="Close">
          <span class="fas fa-times fs--1 text-white"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="bg-white border-top border-bottom border-200 position-relative top-1">
              <div class="table-responsive mx-n1 px-1">
                <table class="table fs--1 mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30%;">Дата</th>
                      <th style="width: 30%;">Пользователь</th>
                      <th>Рейтинг</th>
                      <th>Коментарий</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    @for (item of userVotes; track item) {
                    <tr>
                      <td>
                        {{ item.dateTimeUtc | date: 'dd.MM.yyyy HH:mm' }}
                      </td>
                      <td>
                        <a [routerLink]="[ '/users/edit/' + item.user.id]" data-bs-dismiss="modal">
                          {{item.user.name}} {{ item.user.lastName }} ({{ item.user.userName
                          }})
                        </a>
                      </td>
                      <td>
                        {{ item.rating }}
                      </td>
                      <td>
                        {{ item.comment }}
                      </td>
                    </tr>
                    }
                    @if (isLoadVotes) {
                    <tr>
                      <td colspan="10" class="text-center">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                      </td>
                    </tr>
                    }
                    @if (!isLoadVotes && userVotes.length == 0) {
                    <tr>
                      <td colspan="10" class="text-center">
                        Список пуст
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-primary" type="button" data-bs-dismiss="modal">Закрыть</button>
        </div>
      </div>
    </div>
  </div>